import { ReactComponent as Hands } from "../../../assets/imgs/icons/hands.svg";
import { ReactComponent as Camera } from "../../../assets/imgs/icons/camera.svg";
import { ReactComponent as Mail } from "../../../assets/imgs/icons/mail.svg";
import { ReactComponent as Person } from "../../../assets/imgs/icons/person.svg";
import { ReactComponent as Card } from "../../../assets/imgs/icons/card.svg";
import { ReactComponent as Clocks } from "../../../assets/imgs/icons/clocks.svg";
import { ReactComponent as Guarantee } from "../../../assets/imgs/icons/guarantee.svg";
import { ReactComponent as Property } from "../../../assets/imgs/icons/property.svg";
import { ReactComponent as Danger } from "../../../assets/imgs/icons/danger.svg";

export const rightsData = {
  title: "Умови та положення",
  subtitle:
    'Умови використання послуг "Живі спогади" для розфарбовування та реставрації фотографій.',
  blocks: {
    lead: {
      icon: <Hands />,
      title: "1. Прийняття Умов",
      description: [
        "Користуючись послугами «Живі спогади», ви повністю приймаєте ці умови та положення. Якщо ви не погоджуєтеся з будь-якою з цих умов, будь ласка, не користуйтеся нашими послугами.",
        "Ми залишаємо за собою право оновлювати ці умови в будь-який час, і ваше подальше користування послугами після змін означає прийняття нових умов.",
      ],
    },
    blocks_group: [
      {
        icon: <Camera />,
        title: "2. Пропоновані послуги",
        subtitle: "«Живі спогади» пропонують такі послуги:",
        list: [
          "Розфарбовування чорно-білих фотографій",
          "Відновлення пошкоджених фотографій",
          "Створення професійних відео з фотографій",
          "Додаткові послуги з покращення та налаштування",
        ],
      },
      {
        icon: <Person />,
        title: "3. Обов'язки клієнта",
        subtitle: "Клієнт зобов'язується:",
        list: [
          "Надавати фотографії, на які володіє авторським правом або дозволом на використання",
          "Не завантажувати контент, який є незаконним, наклепницьким або порушує права третіх осіб",
          "Дотримуватись встановлених умов оплати",
          "Чітко донести вимоги та побажання до проекту",
          "Поважати права інтелектуальної власності",
        ],
      },
      {
        icon: <Card />,
        title: "4. Платежі та виставлення рахунків",
        subtitle: "Умови оплати:",
        list: [
          "Усі вказані ціни включають ПДВ",
          "Оплата здійснюється авансом, до початку робіт",
          "Для великих замовлень (понад 1000 лей) можлива оплата частинами",
          "Додаткові витрати будуть повідомлені та затверджені до впровадження",
        ],
      },
      {
        icon: <Clocks />,
        title: "5. Доставка та умови",
        subtitle: "Умови доставки:",
        list: [
          "Терміни доставки є приблизними та можуть змінюватися залежно від складності проекту",
          "Доставка здійснюється електронною поштою або через захищену платформу переказу",
          "Клієнт отримує повідомлення після завершення робіт",
          "За термінові доставки стягується додаткова плата",
          "Затримки, спричинені запитами на зміни, не є нашою відповідальністю",
        ],
      },
      {
        icon: <Guarantee />,
        title: "6. Гарантія та відгуки",
        subtitle: "Наша гарантійна політика:",
        list: [
          "Ми пропонуємо до 2 безкоштовних оглядів на кожен проект",
          "Значні зміни можуть спричинити додаткові витрати",
          "Гарантія поширюється на технічні дефекти, а не на зміни налаштувань",
          "Гарантійний термін становить 30 днів з моменту поставки",
          "Ми прагнемо виконувати роботу професійної якості",
        ],
      },
      {
        icon: <Property />,
        title: "7. Інтелектуальна власність",
        subtitle: "Права інтелектуальної власності:",
        list: [
          "Клієнт залишається власником оригінальних фотографій",
          "Виконані роботи стають власністю замовника після повної оплати",
          "Ми залишаємо за собою право використовувати роботи з портфоліо (за згодою клієнта)",
          "Ми не передаємо права на використані методи та методики",
          "Бренд «Живі спогади» залишається нашою ексклюзивною власністю",
        ],
      },
      {
        icon: <Danger />,
        title: "8. Обмеження відповідальності",
        subtitle: "Наші обмеження відповідальності:",
        list: [
          "Наша відповідальність обмежується вартістю договору",
          "Ми не несемо відповідальності за непрямі збитки або втрачену вигоду",
          "Ми не гарантуємо результатів, ідентичних суб'єктивним очікуванням",
          "Клієнт несе відповідальність за резервне копіювання оригінальних фотографій",
          "Ми не несемо відповідальності за несанкціоноване використання творів третіми особами.",
        ],
      },
    ],
    support: {
      icon: <Mail />,
      title: "9. Контакти та підтримка",
      subtitle:
        "Якщо у вас є запитання щодо цих умов, ви можете зв’язатися з нами:",
      listItems: [
        {
          title: "Електронна пошта:",
          subtitle: "zivispogadi@gmail.com",
        },
        {
          title: "Телефон:",
          subtitle: "+380756921959",
        },
        {
          title: "Графік роботи:",
          subtitle: "понеділок - п'ятниця, 09:00 - 18:00",
        },
      ],
    },
  },
};
